function initVariantQuantityLogic(scope = document) {
  const variantOptions = scope.querySelectorAll('.m-product-option--node');

  if (variantOptions.length > 0) {
    variantOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value') || '';
        const quantityInput = document.querySelector('.m-quantity input');
        if (!quantityInput) return;

        if (value.includes('Geen Set')) quantityInput.value = 1;
        if (value.includes('Set van 2')) quantityInput.value = 2;
        if (value.includes('Set van 4')) quantityInput.value = 4;
        if (value.includes('Set van 6')) quantityInput.value = 6;
      });
    });
  }

  const quantityButtons = scope.querySelectorAll('.m-quantity__button');

  if (quantityButtons.length > 0) {
    quantityButtons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          const quantityInput = document.querySelector('.m-quantity input, input[name="quantity"], #quantity');
          if (!quantityInput) return;

          const qty = parseInt(quantityInput.value, 10);
          let targetTexts = [];

          if (qty === 1) targetTexts = ['Geen Set', 'Ensemble de 1', 'Kein Satz', 'No Set'];
          else if (qty === 2) targetTexts = ['Set van 2', 'Ensemble de 2', '2er-Set', 'Set of 2'];
          else if (qty === 4) targetTexts = ['Set van 4', 'Ensemble de 4', '4er-Set', 'Set of 4'];
          else if (qty === 6) targetTexts = ['Set van 6', 'Ensemble de 6', '6er-Set', 'Set of 6'];
          else return;

          const variantNodes = document.querySelectorAll('.m-product-option--node');
          variantNodes.forEach(node => {
            const label = node.querySelector('label');
            const radioInput = node.querySelector('input[type="radio"]');
            if (!label || !radioInput) return;

            const labelText = label.textContent.trim().toLowerCase();
            targetTexts.forEach(target => {
              if (labelText.includes(target.toLowerCase())) {
                radioInput.checked = true;
                radioInput.dispatchEvent(new Event('change', { bubbles: true }));

                if (window.ProductPage?.updateVariant) {
                  window.ProductPage.updateVariant();
                }
              }
            });
          });
        }, 100);
      });
    });
  }
}


function initDiscountLabels(scope = document) {
  const colorInputs = scope.querySelectorAll('input[name="Kleur"]');
  const optionNodes = scope.querySelectorAll('.m-product-option--node');

  function updateDiscounts() {
    const selectedColorInput = document.querySelector('input[name="Kleur"]:checked');
    if (!selectedColorInput) return;

    const selectedColor = selectedColorInput.value;
    optionNodes.forEach(node => {
      node.querySelectorAll('.discount-info').forEach(d => d.remove());
    });

    const selectedDiscounts = window.discounts?.[selectedColor];
    if (!selectedDiscounts) return;

    for (const set in selectedDiscounts) {
      const text = selectedDiscounts[set];
      optionNodes.forEach(node => {
        const value = node.getAttribute('data-value');
        if (value === set) {
          const div = document.createElement('div');
          div.className = 'discount-info';
          div.style.color = 'red';
          div.style.fontSize = '10px';
          div.textContent = text;
          node.appendChild(div);
        }
      });
    }
  }

  updateDiscounts();
  colorInputs.forEach(input => input.addEventListener('change', updateDiscounts));

  scope.querySelectorAll('.m-product-option--node__label').forEach(label => {
    if (label.textContent.includes('Set van')) {
      label.classList.add('buxiy');
    }
  });

  scope.querySelectorAll('.m-product-option').forEach(option => {
    const label = option.querySelector('.m-product-option--node__label');
    const labelText = label ? (label.textContent || label.innerText) : '';
    if (labelText.toLowerCase().includes('set')) {
      label.classList.add('buxiy');
    }
  });
}


function applyDiscountsFromVariants(scope = document) {
  const scriptTag = scope.querySelector('script[type="application/json"]');
  if (!scriptTag) return;

  let variants = [];
  try {
    variants = JSON.parse(scriptTag.textContent);
  } catch (e) {
    console.error('❌ Varyant JSON çözümlenemedi');
    return;
  }

  const nodes = scope.querySelectorAll('.m-product-option--node__label');
  nodes.forEach(label => {
    const value = label.textContent.trim();
    const match = variants.find(v => v.title === value || v.title.includes(value));
    if (match && match.compare_at_price > match.price) {
      const discount = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
      label.setAttribute('data-discount', discount + '%');

      const d = document.createElement('div');
      d.className = 'discount-info';
      d.style.color = 'red';
      d.style.fontSize = '10px';
      d.textContent = `İndirim: ${discount}%`;
      label.after(d);
    }
  });
}



function initScripts(scope = document) {
  initVariantQuantityLogic(scope);
  initDiscountLabels(scope);
  applyDiscountsFromVariants(scope); // 🔥 buraya ekle
}

document.addEventListener('shopify:section:load', e => initScripts(e.target));
document.addEventListener('shopify:section:select', e => initScripts(e.target));

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    initScripts(document);
  }, 1000);
});
